<template>
    <div id="page-home" class="d-flex flex-column h-100">
        <nav-header v-if="isElectron()"></nav-header>
        <main class="relative">

            <user-resources @changeTab="setView" @openProfile="openProfile"></user-resources>

            <transition name="fade" mode="out-in">
                <adquiz-tab          v-if="currentTab == 'AD_QUIZZES'"        @hideBottomNav="hideBottomNav" @changeTab="setView" @openAdQuizProfit="$refs.adQuizProfit.show()"></adquiz-tab>
                <games-tab           v-if="currentTab == 'CHALLENGES_AND_TRIVIA_QUIZZES'"         @hideBottomNav="hideBottomNav" @changeTab="setView"></games-tab>
                <auctions-shop-tab   v-if="currentTab == 'AUCTIONS'" @hideBottomNav="hideBottomNav" @changeTab="setView" :tab="auctionsShopTab"></auctions-shop-tab>
                <team-referral-tab   v-if="currentTab == 'REFERRALS_AND_TEAMS'" @hideBottomNav="hideBottomNav" @changeTab="setView" :tab="teamReferralsTab" :referralTab="referralTab"></team-referral-tab>
            </transition>


            <div v-if="displayBottomNav" class="bottom-nav container">
                <div class="col-md-6 p-0 m-auto">
                    <div class="bottom-nav-list">
                        <button type="button" @click="currentTab = 'AD_QUIZZES'" :class="'adquiz'+(currentTab == 'AD_QUIZZES' ? ' active' : '') + (giveaway != null ? ' giveaway' : '')"></button>
                        <button type="button" @click="currentTab = 'CHALLENGES_AND_TRIVIA_QUIZZES'" :class="'trivia'+(currentTab == 'CHALLENGES_AND_TRIVIA_QUIZZES' ? ' active' : '')"></button>
                        <button type="button" @click="currentTab = 'AUCTIONS'" :class="'shop'+(currentTab == 'AUCTIONS' ? ' active' : '')"></button>
                        <button type="button" @click="currentTab = 'REFERRALS_AND_TEAMS'" :class="'referral'+(currentTab == 'REFERRALS_AND_TEAMS' ? ' active' : '')"></button>
                    </div>
                </div>
            </div>

            <challenge ref="challenge" @changeTab="setView" @hideBottomNav="hideBottomNav"></challenge>
            <trivia-quiz ref="triviaQuiz" @changeTab="setView" @hideBottomNav="hideBottomNav"></trivia-quiz>
            <super-challenge ref="superChallenge" @changeTab="setView" @hideBottomNav="hideBottomNav"></super-challenge>
            
            <user-profile ref="userProfile" @changeTab="setView"></user-profile>
            <share-popup ref="sharePopup"></share-popup>
            <trivia-quiz-question ref="triviaQuestion"></trivia-quiz-question>
            <super-challenge-question ref="scQuestion"></super-challenge-question>
            <settings-popup ref="settingsPopup"></settings-popup>
            <news-popup ref="newsPopup"></news-popup>
            <team-chat-popup ref="teamChatPopup"></team-chat-popup>

            <auction-info-popup ref="auctionInfoPopup"></auction-info-popup>
            <auction-bid-popup ref="auctionBidPopup"></auction-bid-popup>
            <auction-form-popup ref="auctionFormPopup"></auction-form-popup>
            <auction-question-popup ref="auctionQuestionPopup"></auction-question-popup>
            

            <!-- preload images -->
            <img src="/images/player/sound-on.png" class="invisible"/>
            <img src="/images/player/sound-off.png" class="invisible"/>
            <img src="/images/close-flat.png" class="invisible"/>
            <img src="/images/challenges/type-low-bear2.png" class="invisible"/>
            <img src="/images/home/win-wheel-bg.png" class="invisible"/>
            <img src="/images/home/win-wheel-grass.png" class="invisible"/>
            
            <!-- end preload images -->
        </main>
        <footer-text></footer-text>
    </div>
</template>
<script>
import AdQuizTab from '../home_tabs/AdQuizTab.vue'
import GamesTab from '../home_tabs/GamesTab.vue'
import AuctionsShopTab from '../home_tabs/AuctionsShopTab.vue'
import TeamReferralTab from '../home_tabs/TeamReferralTab.vue'

import UserResources from '../components/UserResources.vue'
import UserProfile from '../components/profile/UserProfile.vue'
import SharePopup from '../components/SharePopup.vue'
import TriviaQuizQuestion from '../components/TriviaQuizQuestion.vue'
import NewsPopup from '../components/NewsPopup.vue'
import SettingsPopup from '../components/SettingsPopup.vue'
import Challenge from '../components/Challenge.vue'
import TriviaQuiz from '../components/TriviaQuiz.vue'
import SuperChallenge from '../components/SuperChallenge.vue'
import SuperChallengeQuestion from '../components/SuperChallengeQuestion.vue'
import ChatPopup from '../components/teams/ChatPopup.vue'
import AuctionInfoPopup from '../components/auctions/AuctionInfoPopup.vue'
import AuctionBidPopup from '../components/auctions/AuctionBidPopup.vue'
import AuctionFormPopup from '../components/auctions/AuctionFormPopup.vue'
import AuctionQuestionPopup from '../components/auctions/AuctionQuestionPopup.vue'

import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import api from '../api'
import io from '../socketio';
import messages from '../messages';
import confetti from '../confettiHelpers'

export default {
    components: {
        Header, Footer, UserResources, Challenge, UserProfile, SharePopup, ChatPopup,
        AdQuizTab, GamesTab, AuctionsShopTab, TeamReferralTab, NewsPopup, SettingsPopup, 
        TriviaQuizQuestion, TriviaQuiz, SuperChallenge, SuperChallengeQuestion, AuctionInfoPopup, 
        AuctionBidPopup, AuctionFormPopup, AuctionQuestionPopup
    },
    scStartTimer: null,
    triviaStartTimer: null,
    giveawayTimer: null,
    data(){
    	return {
            currentTab: "AD_QUIZZES",
            displayBottomNav: true,
            listen: false,
            listenSC: false,
            teamReferralsTab: "team",
            referralTab: 0,
            disconnect: false,
            auctionsShopTab: "auctions"
    	};
    },
    methods:{

        setView(name, target){
            if(name == 'profile'){
                this.$refs.userProfile.show(target);
                return;
            }
            else if(name == 'news'){
                this.$refs.newsPopup.show(target);
                return;
            }
            else if(name == 'settings'){
                this.$refs.settingsPopup.show();
                return;
            }
            else if(name == 'triviaquiz'){
                this.$refs.triviaQuiz.show();
                return;
            }
            else if(name == 'super-challenge'){
                this.$refs.superChallenge.show();
                return;
            }
            else if(name == 'challenge'){
                this.$refs.challenge.show();
                return;
            }
            else if(name === 'auction-info'){
                this.$refs.auctionInfoPopup.show(target);
                return;
            }
            else if(name === 'auction-bid'){
                this.$refs.auctionBidPopup.show(target);
                return;
            }
            else if(name === 'auction-form'){
                this.$refs.auctionFormPopup.show(target);
                return;
            }
            else if(name === 'auction-question'){
                this.$refs.auctionQuestionPopup.show(target);
                return;
            }
            
            else if(name === 'challenge-results'){
                this.$refs.challenge.showResults(target);
                return;
            }
            else if(name === 'AUCTIONS'){
                this.$refs.challenge.hide();
            }
            else if(name === 'referral-tab') {
                this.teamReferralsTab = 'referrals';
                this.referralTab = (target != undefined ? target : 0); 
                name = 'REFERRALS_AND_TEAMS';
            }
            else if(name === 'shop-tab') {
                this.auctionsShopTab = 'shop';
                name = 'AUCTIONS';
            }
            else if(name === 'team-tab') {
                this.teamReferralsTab = 'team';
                name = 'REFERRALS_AND_TEAMS';
            }
            else {
                // reset tabs
                this.auctionsShopTab = 'auctions';
                this.teamReferralsTab = 'team';
            }

            this.currentTab = name;
        },

        hideBottomNav(hide){
            this.displayBottomNav = !hide;
        },

        openProfile(){
            this.$store.dispatch('sound/sfx','Button');
            this.$refs.userProfile.show();
        },

        getTriviaQuiz(){
            this.$store.dispatch('trivia/getQuiz');
        },

        getSuperChallenge(){
            this.$store.dispatch('superChallenge/getChallenge');
        },

        getShop(){
            this.$store.dispatch('shop/getShop');
        },

        clearTQTimers(){
            if(this.triviaStartTimer != null){
                clearInterval(this.triviaStartTimer);
                this.triviaStartTimer = null;
            }
        },

        clearSCTimers(){
            if(this.scStartTimer != null){
                clearInterval(this.scStartTimer);
                this.scStartTimer = null;
            }
        },

        setEvents(){
            if(this.listen) return;
            io.io.on('TRIVIA_QUIZ_START', this.onQuizStart);            
            io.io.on('TRIVIA_QUIZ_NEW_QUESTION', this.onQuizQuestion);            
            io.io.on('TRIVIA_QUIZ_CORRECT_ANSWER', this.onQuizAnswer); 
            io.io.on('TRIVIA_QUIZ_ANSWER_SELECTION_STATS', this.onQuizAnswerSelectionStats); 
            io.io.on('TRIVIA_QUIZ_END', this.onQuizEnd); 

            io.io.on('TRIVIA_QUIZ_INTERLUDE', this.onQuizInterlude);            
            io.io.on('TRIVIA_QUIZ_QUESTION_INTRO', this.onQuizQuestionIntro);            
            io.io.on('TRIVIA_QUIZ_QUESTION_OUTRO', this.onQuizQuestionOutro);
            this.listen = true;            
        },

        removeEvents(){
            io.io.off('TRIVIA_QUIZ_START', this.onQuizStart);            
            io.io.off('TRIVIA_QUIZ_NEW_QUESTION', this.onQuizQuestion);            
            io.io.off('TRIVIA_QUIZ_CORRECT_ANSWER', this.onQuizAnswer); 
            io.io.off('TRIVIA_QUIZ_ANSWER_SELECTION_STATS', this.onQuizAnswerSelectionStats);
            io.io.off('TRIVIA_QUIZ_END', this.onQuizEnd); 
            io.io.off('TRIVIA_QUIZ_INTERLUDE', this.onQuizInterlude);            
            io.io.off('TRIVIA_QUIZ_QUESTION_INTRO', this.onQuizQuestionIntro);            
            io.io.off('TRIVIA_QUIZ_QUESTION_OUTRO', this.onQuizQuestionOutro); 
            this.listen = false;           
        },

        setSCEvents(){
            if(this.listenSC) return;
            io.io.on('SUPER_CHALLENGE_START', this.onSCStart);            
            io.io.on('SUPER_CHALLENGE_QUESTION', this.onSCQuestion);            
            io.io.on('SUPER_CHALLENGE_END', this.onSCEnd); 
            io.io.on('SUPER_CHALLENGE_INTERLUDE', this.onSCInterlude);            
            this.listenSC = true;            
        },

        removeSCEvents(){
            io.io.off('SUPER_CHALLENGE_START', this.onSCStart);            
            io.io.off('SUPER_CHALLENGE_QUESTION', this.onSCQuestion);            
            io.io.off('SUPER_CHALLENGE_END', this.onSCEnd); 
            io.io.off('SUPER_CHALLENGE_INTERLUDE', this.onSCInterlude);            
            this.listenSC = false;           
        },

        onConnect(){
            if(this.disconnect && this.$store.state.auth.loggedIn) {
                this.getTriviaQuiz();
                this.$store.dispatch('giveaway/getActive');
                this.disconnect = false;
            }
        },

        onDisconnect(){
            this.disconnect = true;
        },

// question

        onQuizStart(data){
            // console.log(data);
        },

        onQuizQuestion(question){
            this.$refs.triviaQuestion.setQuestion(question);
        },

        onQuizAnswer(answer){
            this.$refs.triviaQuestion.setAnswer(answer);
        },

        onQuizAnswerSelectionStats(data){
            this.$refs.triviaQuestion.setAnswerStats(data);
        },

        onQuizEnd(results){
            this.$refs.triviaQuestion.setEnd(results);
        },

        onQuizInterlude(data){
            this.$refs.triviaQuestion.setInterlude(data);
        },

        onQuizQuestionIntro(data){
            this.$refs.triviaQuestion.setIntro(data);
        },

        onQuizQuestionOutro(data){
            this.$refs.triviaQuestion.setOutro(data);
        },

        onQuizUpdate(data){
            this.$store.dispatch('trivia/setQuiz', data);
        },

        onGiveawayStart(data){
            this.$store.dispatch('giveaway/setActive', data);
        },


// super challenge

        onSCStart(data){
            // console.log(data);
            this.$store.dispatch('superChallenge/setChallenge', data);
        },

        onSCQuestion(question){
            this.$refs.scQuestion.setQuestion(question);
        },

        onSCEnd(results){
            this.$refs.scQuestion.setEnd(results);
        },

        onSCInterlude(data){
            this.$refs.scQuestion.setInterlude(data);
        },

        onSCUpdate(data){
            this.$store.dispatch('superChallenge/setChallenge', data);
        },


        getReferralAllocations(){
            const $this = this;
            let nt = moment.utc() + $this.networkTimeDiff;
            if(localStorage.referralAllocations != undefined && localStorage.referralAllocations != ""){
                api.referralAllocations(localStorage.referralAllocations)
                .then((response) => {
                    $this.$root.$bvModal.msgBoxConfirm($this.htmlToVNode($this.$t('home.referral_on_start', {amount: response.data.amount.abbr(true), users: response.data.referrals.map(e => e.username).join(",")})), {
                        size: 'sm',
                        buttonSize: 'lg',
                        cancelTitle: this.$t('base.btn_ok'),
                        okTitle: this.$t('home.referral_on_start_view_all_btn'),
                        modalClass: 'confirmModal referralModal',
                        hideHeaderClose: true,
                        centered: true,
                    })
                    .then(value => {
                        if(value === true){
                            $this.setView("referral-tab");
                        }
                    })
                    .then(value => {
                        $this.$store.dispatch('sound/sfx','Button');
                    });
                })
                .catch((error) => {

                });
            }
            // store for next start
            localStorage.referralAllocations = moment.utc(nt).format("YYYY-MM-DDTHH:mm:ss");
        },

        htmlToVNode(html) {
            return [
                this.$createElement('div', { domProps: { innerHTML: html } })
            ]
        }
    },

    created(){
        const $this = this;
        this.getTriviaQuiz();
        this.getSuperChallenge();
        this.getReferralAllocations();
        this.getShop();

        this.$store.dispatch('giveaway/getActive');

        io.io.on('TRIVIA_QUIZ_UPDATE', this.onQuizUpdate); 
        io.io.on('SUPER_CHALLENGE_UPDATE', this.onSCUpdate); 
        io.io.on('GIVEAWAY_START', this.onGiveawayStart); 
        io.io.on('connect', this.onConnect);
        io.io.on('disconnect', this.onDisconnect);
        this.$root.$on('setHomeView', (data) => { $this.setView(data.view, data.target) });
        
        this.currentTab = this.userDefaultScreen;

        if(this.currentTab == "AD_QUIZZES" && this.giveaway != null)
            confetti.fireworks(5);
        
        if(this.user.mtsCustomer)
            document.body.classList.add('theme-mts');
        else
            document.body.classList.remove('theme-mts','theme-auth');
    },

    mounted(){
        messages.init();

        this.$root.$on('openTeamChat', () => {
            this.$refs.teamChatPopup.show();
        })
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },
        userDefaultScreen() {
            return this.user?.defaultAppScreen ?? "AD_QUIZZES";
            //     case "CHALLENGES_AND_TRIVIA_QUIZZES": 
            //         return "games-tab";
            //     case "AUCTIONS":
            //         return "auctions-shop-tab";
            //     default:
            //         return "AD_QUIZZES";
            // }
        }, 
        triviaQuiz() {
            return this.$store.state.trivia.quiz;
        },
        triviaQuizFollow() {
            return this.$store.state.trivia.follow;
        },
        superChallenge() {
            return this.$store.state.superChallenge.obj;
        },
        giveaway(){
            return this.$store.state.giveaway.data;
        },
        networkTimeDiff(){
            return this.$store.state.config.networkTimeDiff;
        }
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
        this.removeEvents();
        io.io.off('connect', this.onConnect);
        io.io.off('disconnect', this.onDisconnect);
        io.io.off('TRIVIA_QUIZ_UPDATE', this.onQuizUpdate);
        io.io.off('GIVEAWAY_START', this.onGiveawayStart); 
        this.$root.$off('setHomeView');
    },

    watch:{
        currentTab(){
            this.displayBottomNav = true;
            this.referralTab = (this.currentTab == 'referral-tab' ? this.referralTab : 0);
            this.$store.dispatch('sound/sfx','Tab_Click');
        },

        user(newValue){
            if(newValue.mtsCustomer)
                document.body.classList.add('theme-mts');
            else
                document.body.classList.remove('theme-mts','theme-auth');
        },

        triviaQuiz(){
            this.clearTQTimers();
            const $this = this;
            if(this.triviaQuiz != null){
                
                
                if(this.triviaQuiz.startDateTime != undefined){
                    this.triviaStartTimer = setInterval(() => { 
                        let nt = moment.utc() + $this.networkTimeDiff;
                        if(moment.utc(nt).isAfter($this.triviaQuiz.startDateTime)){
                            if($this.triviaQuiz.userParticipationStatus == undefined) { console.log("TIMER GET TRIVIA"); $this.getTriviaQuiz(); } 
                            $this.clearTQTimers();
                        }
                    }, 1000);
                }

                if (this.triviaQuiz.userParticipationStatus != undefined && this.triviaQuizFollow) this.setEvents();
                else this.removeEvents();

                if(this.triviaQuiz.status == 'IN_PROGRESS' && this.triviaQuiz.userParticipationStatus != undefined && this.triviaQuizFollow){
                    api.triviaQuizLatestQuestion(this.triviaQuiz.id)
                    .then((response) => {
                        // console.log("'I'll be back'");
                        $this.onQuizQuestion(response.data);
                    });
                }
            }
        },

        superChallenge(){
            if (this.superChallenge != null && this.superChallenge.userApplied) this.setSCEvents();
            else this.removeSCEvents();

            if(this.superChallenge != null){
                const $this = this;
                this.clearSCTimers();
                if(this.superChallenge.startDate != undefined){
                    this.scStartTimer = setInterval(() => { 
                        let nt = moment.utc() + $this.networkTimeDiff;
                        if(moment.utc(nt).isAfter($this.superChallenge.startDate)){
                            if(!$this.superChallenge.userApplied) { console.log("TIMER GET SC"); $this.getSuperChallenge(); } 
                            $this.clearSCTimers();
                        }
                    }, 1000);
                }
            }
        },

        triviaQuizFollow(){
            if (this.triviaQuiz.userParticipationStatus != undefined && this.triviaQuizFollow) this.setEvents();
            else this.removeEvents();
        },


        giveaway(newVal, oldVal){
            if(this.giveawayTimer != null){
                clearInterval(this.giveawayTimer);
                this.giveawayTimer = null;
            }
            if(this.giveaway != null){
                if(oldVal == null) confetti.fireworks(5);
                if(this.giveaway.expirationDateTime != undefined){
                    const $this = this;
                    this.giveawayTimer = setInterval(() => { 
                         let nt = moment.utc() + $this.networkTimeDiff;
                        if(moment.utc(nt).isAfter($this.giveaway.expirationDateTime)){
                            $this.$store.dispatch('giveaway/getActive');
                            clearInterval($this.giveawayTimer);
                            $this.giveawayTimer = null;
                        }
                    }, 1000);
                }
            }
        },
    }
};
</script>
